module.exports = __webpack_public_path__ + "img/logo.637eab43.png";